export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';

export const SHOW_REGISTER_MODAL = 'SHOW_REGISTER_MODAL';

export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL';

export const CLOSE_MODAL = 'CLOSE_MODAL';

